import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material';
import { ReferenceDataService } from 'src/app/Services/AdminConfigurations/reference-data.service';
import { PlanNameService } from 'src/app/Services/AdminConfigurations/plan-name.service';
import { IPlanName } from 'src/app/models/IPlanName';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-plan-name-lookup',
  templateUrl: './plan-name-lookup.component.html',
  styleUrls: ['./plan-name-lookup.component.css']
})
export class PlanNameLookupComponent implements OnInit {
  displayedColumns: string[] = ['payerPlanCode', 'planName', 'action'];

  allPlans: any[] = [];
  filteredPlans: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  searchTerm: string = '';

  existingPlans: IPlanName[] = [];
  private existingKeys = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<PlanNameLookupComponent>,
    private referenceDataService: ReferenceDataService,
    private planService: PlanNameService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.loadExistingPlans();
    this.loadReferencePlans();
  }

  loadExistingPlans() {
    this.planService.getAllPlanNames().subscribe(data => {
      this.existingPlans = data || [];
      this.buildExistingKeys();
      this.stampFlags();
    });
  }

  loadReferencePlans() {
    this.spinner.show();
    this.referenceDataService.getPayerPlans().subscribe(
      (data) => {
        const raw = Array.isArray(data) ? data : (data as any).data || (data as any).result || [];
        this.allPlans = raw.map(c => this.normalize(c));
        this.filteredPlans = [...this.allPlans];
        this.stampFlags();
        this.dataSource.data = this.filteredPlans;
        this.spinner.hide();
        this.cdr.detectChanges();
      },
      (err) => {
        console.error(err);
        this.spinner.hide();
      }
    );
  }

  private normalize(c: any): any {
    return {
      sourceId: c.payerPlanId || c.PayerPlanId || c.id || c.Id,
      payerPlanCode: c.payerPlanCode || c.PayerPlanCode || c.code || c.Code,
      planName: c.planName || c.PlanName || c.name || c.Name,
      isActive: c.isActive != null ? c.isActive : (c.IsActive != null ? c.IsActive : true)
    };
  }

  applySearch() {
    const term = this.searchTerm.trim().toLowerCase();
    if (term) {
      this.filteredPlans = this.allPlans.filter(c =>
        (c.planName && c.planName.toLowerCase().includes(term)) ||
        (c.payerPlanCode && c.payerPlanCode.toLowerCase().includes(term))
      );
    } else {
      this.filteredPlans = [...this.allPlans];
    }
    this.dataSource.data = this.filteredPlans;
  }

  clearSearch() {
    this.searchTerm = '';
    this.applySearch();
  }

  private getKey(name: string): string {
    return (name || '').toLowerCase();
  }

  private buildExistingKeys(): void {
    this.existingKeys.clear();
    this.existingPlans.forEach(e => this.existingKeys.add(this.getKey(e.planName)));
  }

  private stampFlags(): void {
    this.allPlans.forEach(c => {
      c.isExisting = this.existingKeys.has(this.getKey(c.planName));
    });
  }

  addPlan(item: any) {
    this.spinner.show();
    const plan = new IPlanName();
    plan.planName = item.planName;
    plan.payerPlanCode = item.payerPlanCode;
    plan.isActive = true;
    plan.sourceId = item.sourceId;
    (plan as any).facilityId = Number(sessionStorage.getItem('FacilityId'));
    (plan as any).createdBy = encodeURIComponent(sessionStorage.getItem('userId')).toString();

    this.planService.addPlanNameDetails(plan).subscribe(
      (result) => {
        this.toastr.success(result);
        item.isExisting = true;
        this.existingKeys.add(this.getKey(item.planName));
        this.spinner.hide();
        this.cdr.detectChanges();
      },
      (err) => {
        this.toastr.error('Failed to add plan name');
        this.spinner.hide();
      }
    );
  }

  close() {
    this.dialogRef.close({ refreshRequired: true });
  }
}
